var map = {
	"./en/main.json": [
		316,
		1
	],
	"./en/main.kay.json": [
		317,
		2
	],
	"./en/main.peo.json": [
		318,
		3
	],
	"./en/main.zal.json": [
		319,
		4
	],
	"./es/main.json": [
		320,
		5
	],
	"./es/main.zal.json": [
		321,
		6
	],
	"./fr/main.json": [
		322,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 85;
module.exports = webpackAsyncContext;